<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { AvatarVariants } from '.'
import { Avatar, AvatarFallback, AvatarImage } from '.'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<{
  src?: string | null
  name?: string | null
  size?: AvatarVariants['size']
  shape?: AvatarVariants['shape']
  class?: HTMLAttributes['class']
}>(), {
  src: null,
  name: null,
  size: 'default',
  shape: 'circle',
  class: undefined,
})

const initial = computed(() => props.name?.trim().charAt(0).toLocaleUpperCase('ru-RU') || '?')
</script>

<template>
  <Avatar
    :size="size"
    :shape="shape"
    :class="cn('size-10 border-0', props.class)"
  >
    <AvatarImage
      v-if="src"
      :src="src"
      :alt="name || ''"
    />
    <AvatarFallback class="bg-foreground text-background">
      <span>{{ initial }}</span>
    </AvatarFallback>
  </Avatar>
</template>
